import React, { useState, useEffect } from 'react';
import { DropdownButton, Dropdown} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';


function check_variabili_oggetto(obj, ...args) {
    return args.reduce((obj, level) => obj && obj[level], obj)
  }

const Dropdown_classi = (props) => {

    const [value1, setValue1] = useState('');


    const handleSelect = (item_id) => {
        const nuova_classe_id = {
            classe_id: item_id
        }
        console.log(nuova_classe_id)
        
//        let newArr = [...props.lista_domande_render]; // copying the old datas array
//        newArr[props.index].materia_id = item_id; // replace e.target.value with whatever you want to change it to
        /* idroslab da una lista di oggetti con id andare poi a cambiare id */
          
        var result = props.lista_classi.find(item => item._id === item_id);
        console.log(result)
        console.log(result.nome)
/*        if (newArr[props.index].materia_id === undefined) {
            console.log("indefinito")
            const materia = {
                materia: result.materia,
                colore_sfondo: result.colore_sfondo
            }    
            newArr[props.index].materia_id = materia
        }
*/
//        newArr[props.index].materia_id.materia = result.materia; // replace e.target.value with whatever you want to change it to
//        props.SET_lista_domande_render(newArr);


        axios.patch('/alunni/modifica_classe_id/' + props.alunno._id, nuova_classe_id)
            .then((res) => {
                console.log(res.data)

                props.SET_variab_aggiorna(current => !current)
            }).catch((error) => {
                console.log(error)
            });
    }


    function displayStarRating() {
        var stringa
        const btn = { color: "red", margin: "5%", boxShadow: "5px 5px 3px rgba(46, 46, 46, 0.62)" }
        return btn;
    }


    function Inserisci_materia_attuale() {
        let btn 
        btn = check_variabili_oggetto (props.alunno, 'classe_id', 'nome')
        if (btn === null) btn='...'
        return btn
    }

    return (
        <div class="d-flex flex-row-reverse"> 
        <DropdownButton
            variant="primary"
            title={Inserisci_materia_attuale()}
            onSelect={handleSelect} >
            {props.lista_classi.map(function (item1, index2) {
                {
                    return <div>
                        <Dropdown.Item eventKey={item1._id}> {item1.nome} </Dropdown.Item>
                    </div>
                }
            })
            }
            <Dropdown.Divider />
            <Dropdown.Item eventKey="some link">some link</Dropdown.Item>
        </DropdownButton>
        </div>
    )
}

export default Dropdown_classi;